import { render } from "./signup.vue?vue&type=template&id=3b702a3b&class=%20bg-gray-bgcolor%20font-nunito"
import script from "./signup.vue?vue&type=script&lang=js"
export * from "./signup.vue?vue&type=script&lang=js"

import "./signup.vue?vue&type=style&index=0&id=3b702a3b&lang=css"
script.render = render

export default script